import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import * as appbaseTypes from '@appbase/store/types';
import api from '@hr/api/index'
//import ModalSlotLayout from './ModalSlotLayout.vue';
import ModalSlotLayout from '@appbase/containers/ModalContainer/ModalSlotLayout.vue'
import modalHelper from '@appbase/util/modal-helper'
import ModalLayout from '@appbase/templates/ModalLayout/ModalLayout.vue'
import {FormGroup, TextBoxField} from '@appbase/components/forms/index'
import CheckSlider from '@appbase/components/checkbox/CheckSlider.vue';
import { createEventBus, dispatchEventBus } from '../../../../@appbase/util/eventBus';


@Component({
    components: {
        ModalSlotLayout,
        ModalLayout,
        FormGroup,
        TextBoxField,
        CheckSlider
    },
    computed: {
        ...mapGetters({
            isTeams: appbaseTypes.TEAMS,
        })
    } 
})
export default class Modify extends Vue {

    @Prop({ type: Object }) value!: any;

    isModal?: boolean = false;
    isTeams!: boolean
    
    targetId: string = ''

    data: any = {

    }

    async save(){
        let _this = this;
        this.$nextTick(async()=>{
            if(!this.data.name){
                await (window as any).alertAsync(this.$t('기본이름입력'));
                return;
            }

            var max = Number(this.data.max);
            if(isNaN(max)){
                await (window as any).alertAsync(this.$t('M_Common_DateMsg1'));
                return;
            }

            api.leave.setLeaveCode({
                Id: this.data.id,
                Name: this.data.name,
                NameEng: this.data.nameEng,
                NameJpn: this.data.nameJpn,
                NameChi: this.data.nameChi,
                ComCode: this.data.comCode,
                IsDeduct: this.data.isDeduct,
                IsUsing: this.data.isUsing,
                Max: max,
                ModifyUser: ''
            }).then(async res=>{
                if(res==0){
                    await (window as any).alertAsync(_this.$t('휴가코드정보수정성공'));

                    if((window as any).parent){
                        dispatchEventBus((window as any).parent, 'refreshLeaveCode', undefined);
                    }else{
                        dispatchEventBus(window, 'refreshLeaveCode', undefined);
                    }
                    
                    this.handleClose()
                }else{
                    await (window as any).alertAsync(_this.$t('휴가코드정보수정실패')+'\n' + res);
                }
            })
        })

    }

    handleClose() {
        if(this.isModal){
            modalHelper.close();
        }
        else{
            window.close()
        }
        
    }

    created(){
        var paramValue;
        if(this.value) {
            paramValue = this.value;
            this.isModal = true;
        }
        else{
            paramValue = this.$route.query
        }

    }

    mounted(){
        this.targetId = this.$route.query.id as string;

        api.leave.getLeaveCode(this.targetId).then(res=>{
            this.data = res;
        });

    }
}